import React from 'react';
import { Button } from 'antd';
import { doLogin, doLogout, isLoggedIn, getUsername, getFirstName, getLastName, getEmail } from './services/AuthService';

const UserMenu = () => {
  try {
    const loggedIn = isLoggedIn();
    console.log('UserMenu: isLoggedIn =', loggedIn);
    
    if (loggedIn) {
      const username = getUsername();
      const firstName = getFirstName();
      const lastName = getLastName();
      const email = getEmail();
      console.log('UserMenu: username =', username);
      
      return (
        <div style={{ color: 'white', padding: '0 24px', display: 'flex', alignItems: 'center' }}>
          <span style={{ marginRight: '16px' }}>
            Logged in as: {firstName} {lastName} - {email}
          </span>
          <Button 
            onClick={doLogout}
            type="primary"
            ghost
            size="small"
          >
            Logout
          </Button>
        </div>
      );
    }
    
    return (
      <Button 
        onClick={doLogin}
        type="primary"
        style={{ margin: '0 24px' }}
        size="small"
      >
        Login
      </Button>
    );
  } catch (error) {
    console.error('Error in UserMenu component:', error);
    return (
      <Button 
        onClick={() => {}}
        type="primary"
        danger
        style={{ margin: '0 24px' }}
        size="small"
      >
        Login Error
      </Button>
    );
  }
};

export default UserMenu;